import { EditableOption } from '@/shared/types/editable';
import { formatEnum, formatEnumKey } from '@/shared/utils/format';
import { isValidSignedInteger } from '@/shared/utils/validation';

export type Enum = Record<string, string | number>;

export type EnumValues<T> = T[keyof T];

export const enumKeys = (type: Enum) => Object.keys(type).filter((key) => !isValidSignedInteger(key));

export const enumValues = (type: Enum) => enumKeys(type).map((key) => type[key]);

export const enumOptions = (type: Enum, separator = ' ') =>
  enumKeys(type).map((key) => {
    return {
      value: type[key],
      text: formatEnumKey(key)
        .split(' ')
        .map((part) => part.trim())
        .join(separator ?? ' '),
    };
  });

export const editableEnumOptions = (type: any, formatter?: (value: any) => string): EditableOption[] =>
  enumValues(type).map((value) => {
    return {
      value,
      text: formatter ? formatter(value) : formatEnum(type, value),
    };
  });

export const omitEnumValues = <T extends Enum>(enumObj: T, omitValues: (EnumValues<T> | boolean)[]): Partial<T> => {
  const keys = Object.keys(enumObj).filter((key) => isNaN(Number(key)));
  return keys
    .filter((key) => !omitValues.includes(enumObj[key as keyof T]))
    .reduce((result, key) => {
      result[key as keyof T] = enumObj[key as keyof T];
      return result;
    }, {} as Partial<T>);
};
